import { render, staticRenderFns } from "./SchoolAdminLayout.vue?vue&type=template&id=5acd5b95&scoped=true"
import script from "./SchoolAdminLayout.vue?vue&type=script&lang=js"
export * from "./SchoolAdminLayout.vue?vue&type=script&lang=js"
import style0 from "./SchoolAdminLayout.vue?vue&type=style&index=0&id=5acd5b95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acd5b95",
  null
  
)

export default component.exports